import baseAPI from '../axiosApi'

const api={
    list:'/api-ir/international/outgoing/page',
    add:'/api-ir/international/outgoing/add',
    update:'/api-ir/international/outgoing/edit',
    info:'/api-ir/international/outgoing/info/',
    del:'/api-ir/international/outgoing/delete/',
}
// 查询outgoing列表
export function list (data) {
    return baseAPI.axiosData(api.list,'get',data)
}
// 新增outgoing
export function add (data) {
    return baseAPI.axiosData(api.add,'post',data)
}
// 修改outgoing
export function update (data) {
    return baseAPI.axiosData(api.update,'put',data)
}
// 查询outgoing信息
export function info (id) {
    return baseAPI.axiosData(api.info+id,'get')
}
// 删除outgoing
export function del (id) {
    return baseAPI.axiosData(api.del+id,'delete')
}
